import React from 'react'
import { Text } from '@retailer-platform/shared-components'
import { PipelineStep } from '../../../../../../types/attributeManagement.types'
import { PipelineNodeCardPill } from '../PipelineEditorNode'
import { useDomainMessages } from '../../../../../../utils/domain/intl'
import { CampFieldsContainer, IndentedText } from './ControlOverviewPane'

interface FieldPaneProps {
  field: string
}

const FieldPane: React.FC<FieldPaneProps> = ({ field }) => {
  const i18n = useDomainMessages({
    regex:
      'catalogAdminDomain.attributeManagement.stepAttributeForms.pipelineForm.controlRegex.regex',
  })
  return (
    <PipelineNodeCardPill>
      <CampFieldsContainer>
        <Text size={'small'} weight="semibold">
          {' '}
          Camp field{' '}
        </Text>
        <IndentedText size={'small'} weight="regular">
          {field?.trim() ?? 'N/A'}
        </IndentedText>
      </CampFieldsContainer>
    </PipelineNodeCardPill>
  )
}

export default FieldPane
